import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  Button,
} from "@mui/material";

const DeleteWarningDialog = ({
  message = "",
  primaryBtnText = "",
  btnColor,
  onConfirm,
  onCancel,
}) => {
  const [dontShow, setDontShow] = useState(false);

  const handleConfirm = () => {
    if (dontShow) {
      sessionStorage.setItem("hideTemplateDeleteWarning", "true");
    }
    onConfirm();
  };

  return (
    <Box>
      <Box
        sx={{
          p: "1rem",
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <Typography variant="body2" sx={{ fontSize: "1.2rem" }}>
          {message}
        </Typography>
        <FormControlLabel
          control={
            <Checkbox
              size="small"
              checked={dontShow}
              onChange={(e) => setDontShow(e.target.checked)}
            />
          }
          label="Don't show this again"
          sx={{ fontSize: "0.8rem", color: "text.secondary" }}
        />
      </Box>
      <Box
        sx={{
          height: "fit-content",
          borderTop: "1px solid #ddd",
          position: "sticky",
          bottom: 0,
          backdropFilter: "blur(10px)",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          p: "0.5rem",
          zIndex: 1000,
          gap: "0.5rem",
          bgcolor: "rgba(255, 255, 255, 0.8)",
        }}
      >
        <Button variant="outlined" size="small" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          variant="contained"
          size="small"
          onClick={handleConfirm}
          sx={{
            bgcolor: `${btnColor}.main`,
            "&:hover": { bgcolor: `${btnColor}.dark` },
          }}
        >
          {primaryBtnText}
        </Button>
      </Box>
    </Box>
  );
};

export default DeleteWarningDialog;
